import { takeLatest, put, call, select, debounce } from 'redux-saga/effects';
import {
    GET_CONTACTS_REQUEST,
    getContactsSuccess,
    getContactsFailure,
    SUBMIT_CONTACT_REQUEST,
    submitContactsSuccess,
    submitContactsFailure,
    GET_TYPING_CONTACTS_REQUEST,
    GET_CONTACT_REQUEST,
    getContactSuccess,
    getContactFailure
} from '../actions/contacts';
import { getContacts, postContacts, putContacts } from '../services/contacts';
import { showGlobalError } from '../../app/actions/app';
import { accessTokenSelector } from '../../auth/selectors/token';
import { getClients } from "../../clients/services/clients";
import { getAccountProfile } from "../../clients/sagas/clients";
import { buildUsersInContact } from '../helpers/contacts'

export const getContactsWorker = function* ({ payload: { filters } }) {
    try {
        const token = yield select(accessTokenSelector);

        const {
            data: { contacts, total }
        } = yield call(getContacts, filters, token);

        yield put(getContactsSuccess(contacts, total));
    } catch (err) {
        yield put(getContactsFailure(err));
        yield put(showGlobalError(true, err));
    }
};

export const getContactWorker = function* ({ payload: { filters, alsoLookForClients = false } }) {
    try {
        const token = yield select(accessTokenSelector);

        let contact = {};

        const {
            data: { contacts }
        } = yield call(getContacts, filters, token);

        if (contacts.length) {
            contact = contacts[0];
        }

        if (alsoLookForClients && !contacts.length) {
            const { data: { users } } = yield call(getClients, { ...filters, identifier: filters._id, full_company: 1 }, token);

            if (users.length) {
                contact = buildUsersInContact(users[0]);
            }
        }

        yield put(getContactSuccess(contact));
    } catch (err) {
        yield put(getContactFailure(err));
        yield put(showGlobalError(true, err));
    }
};

const submitContactsWorker = function* ({ payload: { contact } }) {
    try {
        const token = yield select(accessTokenSelector);

        let respContact = { ...contact };

        if (!contact._id) {

            const { data } = yield call(postContacts, contact, token);

            respContact = { ...data.contact };

            yield put(showGlobalError(true, 200, 'created'));
        } else {
            yield call(putContacts, contact, token);
            yield put(showGlobalError(true, 200, 'updated'));
        }

        yield put(submitContactsSuccess(respContact));
    } catch (err) {
        if (err && err.response && err.response.status && err.response.status === 409) {
            yield put(showGlobalError(true, 409, 'user_already_exist'));
        } else {
            yield put(showGlobalError(true, err));
        }
        yield put(submitContactsFailure(err));
    }
};

const getTypingContactsWorker = function* ({ payload: { filters, alsoLookForClients = false } }) {

    try {
        let respContactsAndClients = [];
        let respTotals = 0;

        const token = yield select(accessTokenSelector);

        const { data: { contacts, total: total_constacts } } = yield call(getContacts, filters, token);

        respContactsAndClients = [
            ...contacts
        ];
        respTotals += total_constacts;

        if (alsoLookForClients) {
            const profileAccount_id = yield call(getAccountProfile);

            const { data: { users, total: total_clients } } = yield call(getClients, { ...filters, text: filters.searchText }, token, profileAccount_id);

            respContactsAndClients = [
                ...respContactsAndClients,
                ...users.map(user => buildUsersInContact(user))
            ];

            respTotals += total_clients;
        }

        yield put(getContactsSuccess(respContactsAndClients, respTotals));

    } catch (err) {
        yield put(getContactsFailure(err));
        yield put(showGlobalError(true, err));
    }
}

export default [
    debounce(500, GET_TYPING_CONTACTS_REQUEST, getTypingContactsWorker),
    takeLatest(GET_CONTACTS_REQUEST, getContactsWorker),
    takeLatest(SUBMIT_CONTACT_REQUEST, submitContactsWorker),
    takeLatest(GET_CONTACT_REQUEST, getContactWorker)
];
